import React from 'react';
import { ReasonSelectionModal } from './ReasonSelectionModal';

const CancelAppointmentModal = (props) => {
  return <ReasonSelectionModal {...props} reasonType="cancel" />;
};

export { CancelAppointmentModal };
